import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "minibusFilled"
const MinibusFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 14.25C7.036 14.25 7.875 15.09 7.875 16.125S7.035 18 6 18 4.125 17.16 4.125 16.125 4.965 14.25 6 14.25M18 14.25C19.035 14.25 19.875 15.09 19.875 16.125S19.035 18 18 18 16.125 17.16 16.125 16.125 16.965 14.25 18 14.25" />
          <path
            fillRule="evenodd"
            d="M17.513 6.938C18.03 6.938 18.5 7.243 18.712 7.717L19.913 10.419 21.16 10.835C21.848 11.065 22.313 11.709 22.313 12.435V13.313H21.375C21.065 13.313 20.813 13.565 20.813 13.876S21.064 14.438 21.375 14.438H22.313V16.125C22.313 16.643 21.893 17.063 21.375 17.063H20.452C20.563 16.77 20.625 16.455 20.625 16.125 20.625 14.675 19.45 13.5 18 13.5S15.375 14.675 15.375 16.125C15.375 16.455 15.437 16.771 15.548 17.063H8.452C8.564 16.77 8.625 16.455 8.625 16.125 8.625 14.675 7.45 13.5 6 13.5S3.375 14.675 3.375 16.125C3.375 16.455 3.436 16.771 3.548 17.063H2.625C2.107 17.063 1.688 16.643 1.688 16.125V14.438H2.625C2.935 14.438 3.188 14.186 3.188 13.875S2.936 13.313 2.625 13.313H1.688V11.55L2.638 8.062H2.25C1.94 8.063 1.688 7.812 1.688 7.5 1.688 7.19 1.939 6.938 2.25 6.938zM5.952 10.313H8.438V8.063H6.45zM9.562 10.313H13.313V8.063H9.563zM14.439 10.313H18.633L17.684 8.172C17.654 8.107 17.587 8.064 17.513 8.064H14.437z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MinibusFilledIcon
